import { SettingsService } from './settings-service';

export default SettingsService;
